export default __webpack_public_path__ + "files/2a8c0b1b24fe26f9bfcfc0cfbaddb838.svg";